import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { LAZY_BUSY_STATE_STREAMS_CHANGED } from './busy-state.provider';
import { clearBusySignalId, getBusySignalId, setBusySignalId } from './lazy-busy-state-stream-loader-utils';

@Injectable({ providedIn: 'root' })
export class LazyBusyStateStreamLoader {
    private readonly lazyBusyStreams = new Map<symbol, Observable<boolean>>();
    private readonly lazyBusyStreamsChanged = inject(LAZY_BUSY_STATE_STREAMS_CHANGED);

    public registerLazyBusyStateStream(busy$: Observable<boolean>): void {
        // Busy signal has already been registered. Skip registration.
        if (getBusySignalId(busy$)) return;

        const id = setBusySignalId(busy$);

        this.lazyBusyStreams.set(id, busy$);
        this.notifyOfLazyStreamChange();
    }

    public unregisterLazyBusyStateStream(busy$: Observable<boolean>): void {
        const id = getBusySignalId(busy$);

        // Busy signal is not registered.
        if (!id) return;

        clearBusySignalId(busy$);

        this.lazyBusyStreams.delete(id);
        this.notifyOfLazyStreamChange();
    }

    private notifyOfLazyStreamChange(): void {
        const currentStreams = Array.from(this.lazyBusyStreams.values());

        this.lazyBusyStreamsChanged.next(currentStreams);
    }
}
